module.exports = __webpack_public_path__ + "static/mascot-bigcommerce-487df27311e50497d3568b6f0f82430d.png";